import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'
import VsButton from '@/components/vision/VsButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineCommentBox',
  props: {
    color: { default: 'blue lighten-4' },
    loading: { type: Boolean, default: false }
  },
  emits: ['submit'],
  setup(__props: any, { emit }) {

const props = __props as { color: string, loading: boolean }





const commentValue = ref('')
const onInput = (e: string) => {
  commentValue.value = e
}
const submitComment = () => {
  if (commentValue.value) {
    emit('submit', commentValue.value)
    commentValue.value = ''
  }
}

return { __sfc: true,props, emit, commentValue, onInput, submitComment, VsTextInput, VsButton }
}

})